function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-phone-call",
  "data-name": "Icon feather-phone-call",
  d: "M18.936,6.375a6.094,6.094,0,0,1,4.814,4.814M18.936,1.5a10.968,10.968,0,0,1,9.689,9.677M27.406,20.9v3.656A2.437,2.437,0,0,1,24.749,27a24.118,24.118,0,0,1-10.518-3.741,23.765,23.765,0,0,1-7.312-7.312A24.118,24.118,0,0,1,3.178,5.376,2.437,2.437,0,0,1,5.6,2.719H9.259a2.437,2.437,0,0,1,2.437,2.1,15.648,15.648,0,0,0,.853,3.425A2.437,2.437,0,0,1,12,10.811l-1.548,1.548a19.5,19.5,0,0,0,7.312,7.312l1.548-1.548a2.437,2.437,0,0,1,2.571-.548,15.648,15.648,0,0,0,3.425.853A2.437,2.437,0,0,1,27.406,20.9Z",
  transform: "translate(-2.167 -0.396)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
});

var SvgAudio = function SvgAudio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.563,
    height: 27.612,
    viewBox: "0 0 27.563 27.612",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio.155286e4.svg";
export { ForwardRef as ReactComponent };